import React from 'react';
import moment from 'moment';
import {get} from 'lodash';

import TableHeader from './TableHeader';
import ImageLoader from './ImageLoader';

const VideoModerationsList = ({
  videoModerations = [],
  total = 0,
}) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2' title="Video Moderation">Video AI Task</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} tasks</p>
        </div>
      </div>

      <div className='Table Table--video-moderations-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'ID',
              sortKey: 'id',
            },
            {
              label: 'Post ID'
            },
            {
              label: 'Video ID'
            },
            {
              label: 'Posmoni ID'
            },
            {
              label: 'Status',
              sortKey: 'status'
            },
            {
              label: 'Created at'
            },
            {
              label: 'Updated at',
              sortKey: 'updated_at'
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {videoModerations.map((videoModeration) => (
          <div
            className='Table__row'
            key={`${videoModeration.id}_${videoModeration.createdAt}`}
            data-x={videoModeration}
          >
            <div className='Table__col'>{videoModeration.id}</div>
            <div className='Table__col'>
              {videoModeration.postId &&
                <a
                  className='Table__a'
                  href={`/${gon.currentProvider}/posts/${videoModeration.postId}`}
                >
                  {videoModeration.postId}
                </a>
              }
            </div>

            <div className='Table__col'>{videoModeration.videoId}</div>
            <div className='Table__col'>{videoModeration.externalId}</div>
            <div className='Table__col'>{videoModeration.status}</div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: videoModeration.createdAt !== null ?
                    moment(videoModeration.createdAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />
            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: videoModeration.updatedAt !== null ?
                    moment(videoModeration.updatedAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default VideoModerationsList
